<template>
  <v-container>
    <v-card color="#efefef" v-if="invoice.competence !== ''">
      <v-card-title primary-title>
        <v-icon large left color="teal">mdi-wallet</v-icon>
        <div>
          <div class="headline" color="white">Fatura Total</div>
          <span class="grey--text">{{ invoice.competence }}</span>
        </div>
      </v-card-title>
      <v-card-text>
        <v-list subheader>
          <v-list-tile avatar>
            <v-list-tile>Pagamento concessionária</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action
              >R$
              {{ invoice.total_invoice | formatCurrency }}</v-list-tile-action
            >
          </v-list-tile>
          <v-divider />
          <v-list-tile avatar>
            <v-list-tile>Custo de Disponibilidade</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action
              >R$ {{ invoice.custo_disp | formatCurrency }}</v-list-tile-action
            >
          </v-list-tile>
          <v-divider />
          <v-list-tile avatar>
            <v-list-tile>Créditos recebidos:</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action
              >R$ {{ invoice.amount | formatCurrency }}</v-list-tile-action
            >
          </v-list-tile>
          <v-divider />
          <v-list-tile avatar>
            <v-list-tile>Mensalidade:</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action
              >R$ {{ invoice.total | formatCurrency }}</v-list-tile-action
            >
          </v-list-tile>
          <v-divider />
          <v-list-tile avatar>
            <v-list-tile>Antes você pagaria:</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action display-1
              >R$
              {{
                invoice.total_utility_company | formatCurrency
              }}</v-list-tile-action
            >
          </v-list-tile>
          <v-divider />
          <v-list-tile avatar>
            <v-list-tile>Agora você paga:</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action display-1
              >R$
              {{
                (invoice.total_invoice + invoice.amount * 0.8) | formatCurrency
              }}</v-list-tile-action
            >
          </v-list-tile>
          <v-divider />
          <v-list-tile avatar>
            <v-list-tile>Economia:</v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action display-1
              >R$ {{ invoice.discount | formatCurrency }}</v-list-tile-action
            >
          </v-list-tile>
        </v-list>
        <v-card
          v-for="newInvoice in invoice.consumerunits"
          :key="newInvoice.installation_number"
        >
          <v-card-text>
            <v-list subheader>
              <v-subheader>{{ newInvoice.consumer_unit }}</v-subheader>
              <v-list-tile avatar>
                <v-list-tile>Pagamento concessionária</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action
                  >R$
                  {{
                    newInvoice.total_invoice | formatCurrency
                  }}</v-list-tile-action
                >
              </v-list-tile>
              <v-divider />
              <v-list-tile avatar>
                <v-list-tile>Custo de Disponibilidade</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action
                  >R$
                  {{
                    newInvoice.custo_disp | formatCurrency
                  }}</v-list-tile-action
                >
              </v-list-tile>
              <v-divider />
              <v-list-tile avatar>
                <v-list-tile>Créditos recebidos:</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action
                  >R$
                  {{ newInvoice.amount | formatCurrency }}</v-list-tile-action
                >
              </v-list-tile>
              <v-divider />
              <v-list-tile avatar>
                <v-list-tile>Mensalidade:</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action
                  >R$
                  {{ newInvoice.total | formatCurrency }}</v-list-tile-action
                >
              </v-list-tile>
              <v-divider />
              <v-list-tile avatar>
                <v-list-tile>Antes você pagaria:</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action display-1
                  >R$
                  {{
                    newInvoice.total_utility_company | formatCurrency
                  }}</v-list-tile-action
                >
              </v-list-tile>
              <v-divider />
              <v-list-tile avatar>
                <v-list-tile>Agora você paga:</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action display-1
                  >R$
                  {{
                    (newInvoice.total_invoice + newInvoice.amount * 0.8)
                      | formatCurrency
                  }}</v-list-tile-action
                >
              </v-list-tile>
              <v-divider />
              <v-list-tile avatar>
                <v-list-tile>Economia:</v-list-tile>

                <v-list-tile-content>
                  <v-list-tile-title></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action display-1
                  >R$
                  {{ newInvoice.discount | formatCurrency }}</v-list-tile-action
                >
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
        <v-flex xs12 md12 text-xs-right>
          <v-icon left color="danger" @click="limparFatura">delete</v-icon>
          <v-btn
            class="mx-0 font-weight-light"
            color="teal"
            :loading="loading"
            @click.prevent="setInvoice(invoice)"
            :disabled="loading"
          >
            <v-icon left dark>mdi-wallet</v-icon>Adicionar Fatura
          </v-btn>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  props: ["invoice", "newInvoice", "loading"],
  data() {
    return {};
  },
  methods: {
    limparFatura() {
      this.newInvoices = [];
      this.invoice = {
        competence: "",
        amount: 0,
        amount_kW: 0,
        total: 0,
        discount: 0,
        consumerunits: [],
        total_invoice: 0,
        total_amount: 0,
      };
    },
    setInvoice(invoice) {
      this.loading = true;
      this.$emit("setInvoice", invoice);
    },
  },
};
</script>
